import React from "react";
import * as CHQ from "chq";
import { Link } from "react-router-dom";

import { ProfileLink } from "app/links";
import { Trans } from "app/utils";

import NotificationBody from "./NotificationBody";

type EngageStoryNotificationProps = {
  notification: CHQ.NotificationEngageStory;
  tabIndex?: number;
};

const EngageStoryNotification: React.FC<EngageStoryNotificationProps> = ({
  notification: { actor, entity: story }, tabIndex
}) => (
  <NotificationBody actor={actor}>
    <ProfileLink user={actor} tabIndex={tabIndex || 0} />
    {" "}
    <Trans>
      shared
      {" "}
      <Link to={`/stories/trend/${story?.question?.id}/story/${story?.id}/engage`} tabIndex={tabIndex || 0}>
        a social post.
      </Link>
      {" "}
      Support {actor?.name} by adding
      {" "}
      <Link to={`/stories/trend/${story?.question?.id}/story/${story?.id}/engage`} tabIndex={tabIndex || 0}>
        a like and/or comment!
      </Link>
    </Trans>
  </NotificationBody>
);

export default EngageStoryNotification;
